(function () {
  const ChatForm = () => {
    const showWaitingMessage = () => {
      const waitingMessage = document.getElementById('waiting-message');
      waitingMessage?.classList.replace('hidden', 'flex');
    }

    const showSelectedValueMessage = () => {
      const toast = document.getElementById('toast-success');

      toast.classList.replace('hidden', 'flex');
      toast.style.opacity = '1';

      setTimeout(() => {
        toast.style.opacity = '0';

        setTimeout(() => {
          toast.classList.replace('flex', 'hidden');
        }, 300);
      }, 700);
    }

    return {
      selectedFiles: [],
      filesCount: 0,
      hasFiles: false,

      insertSelectedValue(el) {
        const value = el.value;

        if (!value) return;

        const input = document.getElementById('text');
        const currentText = input.value;

        input.value = currentText ? `${currentText} ${value} ` : `${value} `;

        el.slim.setSelected('');

        showSelectedValueMessage();
      },

      handleEnter(event) {
        if (event.shiftKey) return;

        event.preventDefault();

        this.submitMessage();
      },

      triggerFileSelect() {
        this.$refs.fileField.click();
      },

      handleFileChange(event) {
        const newFiles = Array.from(event.target.files);
        this.selectedFiles = [...this.selectedFiles, ...newFiles];
        this.updateFileStats();
        event.target.value = '';
      },

      removeFile(index) {
        this.selectedFiles.splice(index, 1);
        this.updateFileStats();
      },

      updateFileStats() {
        this.filesCount = this.selectedFiles.length;
        this.hasFiles = this.filesCount > 0;
      },

      submitMessage() {
        const input = this.$refs.input;
        if (!input.value.trim() && !this.hasFiles) return;

        if (this.$refs.fileField) {
          const dt = new DataTransfer();
          this.selectedFiles.forEach(file => dt.items.add(file));
          this.$refs.fileField.files = dt.files;
        }

        document.getElementById('form-message').requestSubmit();

        input.value = '';

        this.selectedFiles = [];
        this.updateFileStats();

        showWaitingMessage();

        this.$nextTick(() => {
          const list = document.getElementById('message-list');
          if (list) list.scrollTop = list.scrollHeight;
        })
      }
    }
  };

  if (typeof window !== 'undefined') {
    window.ChatForm = ChatForm;
  };

  return ChatForm;
})();
